import { createAction } from '@reduxjs/toolkit'

export const setCompany = createAction('finalizedDelivery/setCompany')
export const setDriver = createAction('finalizedDelivery/setDriver')